import type React from 'react'

import { NoData } from '@/components/DecisionPanelCards/Shared'
import type { Application } from '@/types/Activity'
import { isEnglishTenancy } from '@/utils/application'

interface Props {
  application: Application
  rightToRentShareCode: string | undefined
  rightToRentContext: string | undefined
}

const ShareCode: React.FC<Props> = ({
  application,
  rightToRentShareCode,
  rightToRentContext,
}) => {
  return (
    <>
      <div>
        <h4>Share Code</h4>
        {!isEnglishTenancy(application) ? (
          <>
            <p>
              <strong>
                <em>NOT REQUIRED</em>
              </strong>{' '}
              - Property is based in Scotland or Wales.
            </p>
          </>
        ) : rightToRentShareCode !== undefined &&
          rightToRentShareCode !== null &&
          rightToRentShareCode !== '' ? (
          <span>
            <strong>{rightToRentShareCode}</strong>
          </span>
        ) : (
          <>
            <NoData>No share code provided</NoData>{' '}
            {rightToRentContext !== undefined && <div>{rightToRentContext}</div>}
          </>
        )}
      </div>
    </>
  )
}

export default ShareCode
